import { gql } from "@apollo/client"

const GET_PREVIEW_DELETED_BOOKING_SLOTS_EMAIL = gql`
  query($input: PreviewDeletedBookingSlotsEmailInput!) {
    previewDeletedBookingSlotsEmail(input: $input) {
      html
      text
    }
  }
`

export { GET_PREVIEW_DELETED_BOOKING_SLOTS_EMAIL }